import moment from 'moment-timezone';
import { TIMEZONE_MAP } from 'utils/common-util';

export const parseStoredIbpDate = (
  value: string | null,
  kind: 'start' | 'end'
): Date | null => {
  if (!value) return null;

  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const tz = TIMEZONE_MAP.CST || 'America/Chicago';
    return kind === 'start'
      ? moment.tz(value, 'YYYY-MM-DD', tz).startOf('day').toDate()
      : moment.tz(value, 'YYYY-MM-DD', tz).endOf('day').toDate();
  }

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const syncIbpDateRangeFromStorage = (
  setDateRangeType: (value: string) => void,
  setCustomStartDate: (value: Date | null) => void,
  setCustomEndDate: (value: Date | null) => void,
) => {
  const savedType = sessionStorage.getItem('IBPDateRangeType') || 'today';
  const savedStart = sessionStorage.getItem('IBPStartDate');
  const savedEnd = sessionStorage.getItem('IBPEndDate');

  setDateRangeType(savedType);
  setCustomStartDate(parseStoredIbpDate(savedStart, 'start'));
  setCustomEndDate(parseStoredIbpDate(savedEnd, 'end'));
};
